import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import IconBase from "./IconBase";
var ArrowDown = function(_param) {
    var _width = _param.width, width = _width === void 0 ? 16 : _width, _height = _param.height, height = _height === void 0 ? 8 : _height, _color = _param.color, color = _color === void 0 ? "white" : _color, props = _object_without_properties(_param, [
        "width",
        "height",
        "color"
    ]);
    return /*#__PURE__*/ _jsx(IconBase, _object_spread_props(_object_spread({
        $styles: {
            width: width,
            height: height
        },
        viewBox: "0 0 15 12"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M1 1L9 9L17 1",
            stroke: color,
            strokeWidth: "2",
            strokeLinecap: "round"
        })
    }));
};
export default ArrowDown;
